import * as React from "react";
function MdIcon() {
    return React.createElement("path", { d: "M3.41675 17.5831V4.41646H6.57702V2.32031H7.69237V4.41646H12.3398V2.32031H13.4231V4.41646H16.5834V17.5831H3.41675ZM4.50006 16.4998H15.5001V9.25621H4.50006V16.4998ZM4.50006 8.1729H15.5001V5.49977H4.50006V8.1729Z", fill: "currentColor" });
}
export default MdIcon;
//# sourceMappingURL=Md.js.map